export const getWebexUrlFromDescription = (description: string): string | null => {
  const regex = new RegExp(/href="(.*?)"/, 'g')
  if (!regex) return null;
  const regexExec = regex.exec(description)
  if (!regexExec || !regexExec[1]) return null;
  return regexExec[1]
}
